import { updatesItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[960px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-3">最近更新</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">平台动态与内容更新快讯，第一时间了解最新变化</p>
        <div className="relative pl-8 md:pl-10 border-l-2 border-primary-200">
          {updatesItems.map((item) => (
            <div key={item.id} className="relative mb-8 last:mb-0">
              <div className="absolute -left-[29px] md:-left-[33px] w-4 h-4 rounded-full bg-primary-500 border-4 border-background-100"></div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 mb-1">
                <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2.5 py-0.5 rounded-full whitespace-nowrap w-fit">
                  {item.date}
                </span>
                <span className="text-xs font-medium text-secondary-700 bg-secondary-100 px-2.5 py-0.5 rounded-full whitespace-nowrap w-fit">
                  {item.tag}
                </span>
              </div>
              <p className="text-sm md:text-base text-foreground-800 font-medium">{item.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}